import AccordionDetails from '@mui/material/AccordionDetails';
import React from 'react';
import GeneralDetailsMyAccounts from 'app/components/AccordionTypes/MyAccounts/GeneralDetailsMyAccounts';
import GeneralDetailsInbank from 'app/components/AccordionTypes/InBank/GeneralDetailsInbank';
import GeneralDetailsCredit from 'app/components/AccordionTypes/Credit/GeneralDetailsCredit';
import GeneralDetailsAbroad from 'app/components/AccordionTypes/Abroad/GeneralDetailsAbroad';
import GeneralDetailsEDV from 'app/components/AccordionTypes/EDV/GeneralDetailsEDV';
import GeneralDetailsBudget from 'app/components/AccordionTypes/Budget/GeneralDetailsBudget';
import GeneralDetailsConversion from 'app/components/AccordionTypes/Conversion/GeneralDetailsConversion';
import GeneralDetailsCountry from 'app/components/AccordionTypes/Country/GeneralDetailsCountry';
import { useLocation } from 'react-router-dom';
import logger from 'app/utils/logger';

interface SelectProps {
  value: string;
  label: string;
}

interface DetailsProps {
  type: string;
  countryDetails: any;
  value?: SelectProps | null;
  change?: (newValue: any) => void;
  accountOptions?: any;
  selectedToAccount?: any;
  onChangeToAccount?: (value: any) => void;
  control?: any;
  register?: any;
  disabled?: boolean;
  errors?: any;
  beneficiarData?: any;
  values?: any;
  handleChangeCustomerType?: any;
  customerType?: any;
  bankCodeLocalTransferOpen?: any;
  bankCodeLocalTransferSet?: any;
  localTransferBankData?: any;
  getBankCodeData?: any;
  transferData?: any;
  clickLocalTransferBankCode?: any;
  setIsSearch?: any;
  switchSelf?: any;
  selfPayment?: any;
  ipsValue?: any;
  handleChangeIps?: any;
  dataIps?: any;
  handleSearchIps?: any;
  edvBudgetData?: any;
  budgetLevelCodes?: any;
  handleChangeSelectedBudgetValue?: any;
  selectedBudgetLevelCodes?: any;
  orgOpen?: any;
  orgClose?: any;
  getOrgData?: any;
  clickOrgCode?: any;
  budgetOrgCodeChange?: any;
  countries?: any;
  selectedCountry?: any;
  handleChangeCountry?: any;
  mediatorBank?: any;
  handleSwitchMediatorBank?: any;
  openDialogSwiftBic?: any;
  setOpenDialogSwiftBic?: any;
  openMediatorDialogSwiftBic?: any;
  setOpenMediatorDialogSwiftBic?: any;
  getSwiftCode?: any;
  handleClickSwiftCode?: any;
  handleClickMediatorSwiftCode?: any;
  dataForm?: any;
  bankCodeValueLocal?: any;
  handleSearchMediatorSwift?: any;
  handleSearchSwift?: any;
  setSwiftMediatorCodeForeign?: any;
  setSwiftCodeForeign?: any;
  budgetClassCode?: any;
  classCodeBudget?: any;
  dataOrganization?: any;
  dataClassification?: any;
  beneficiarDataLocal?: any;
  selectedFromAccount?: any;
  dataSwiftCode?: any;
  ibanField?: any;
  budgetIban?: any;
  voenEdv?: any;
  beneficiarNameEdv?: any;
  handleChangeVoenEdv?: any;
  handleChangeBeneficiarNameEdv?: any;
  innForeign?: any;
  kppForeign?: any;
  beneficiarNameForeign?: any;
  beneficiarAddressForeign?: any;
  handleChangeInnForeign?: any;
  handleChangeKppForeign?: any;
  handleChangeBeneficiarNameForeign?: any;
  handleChangeBeneficiarAddressForeign?: any;
  voenLocal?: any;
  beneficiarIbanLocal?: any;
  beneficiarNameLocal?: any;
  handleChangeBeneficiarIbanLocal?: any;
  handleChangeVoenLocal?: any;
  handleChangeBeneficiarNameLocal?: any;
}

const GeneralDetails = (props: DetailsProps) => {
  const {
    type,
    countryDetails,
    value,
    change,
    onChangeToAccount,
    selectedToAccount,
    accountOptions,
    control,
    register,
    disabled,
    errors,
    beneficiarData,
    values,
    handleChangeCustomerType,
    customerType,
    bankCodeLocalTransferOpen,
    bankCodeLocalTransferSet,
    localTransferBankData,
    getBankCodeData,
    transferData,
    clickLocalTransferBankCode,
    setIsSearch,
    selfPayment,
    switchSelf,
    ipsValue,
    handleChangeIps,
    dataIps,
    handleSearchIps,
    edvBudgetData,
    budgetLevelCodes,
    handleChangeSelectedBudgetValue,
    selectedBudgetLevelCodes,
    orgOpen,
    orgClose,
    getOrgData,
    clickOrgCode,
    budgetOrgCodeChange,
    countries,
    handleChangeCountry,
    selectedCountry,
    mediatorBank,
    handleSwitchMediatorBank,
    openDialogSwiftBic,
    setOpenDialogSwiftBic,
    openMediatorDialogSwiftBic,
    setOpenMediatorDialogSwiftBic,
    getSwiftCode,
    handleClickSwiftCode,
    handleClickMediatorSwiftCode,
    dataForm,
    bankCodeValueLocal,
    handleSearchMediatorSwift,
    handleSearchSwift,
    setSwiftMediatorCodeForeign,
    setSwiftCodeForeign,
    budgetClassCode,
    classCodeBudget,
    dataClassification,
    dataOrganization,
    beneficiarDataLocal,
    selectedFromAccount,
    dataSwiftCode,
    ibanField,
    budgetIban,
    voenEdv,
    beneficiarNameEdv,
    handleChangeVoenEdv,
    handleChangeBeneficiarNameEdv,
    innForeign,
    kppForeign,
    beneficiarNameForeign,
    beneficiarAddressForeign,
    handleChangeInnForeign,
    handleChangeKppForeign,
    handleChangeBeneficiarNameForeign,
    handleChangeBeneficiarAddressForeign,
    voenLocal,
    beneficiarIbanLocal,
    beneficiarNameLocal,
    handleChangeBeneficiarIbanLocal,
    handleChangeVoenLocal,
    handleChangeBeneficiarNameLocal,
  } = props;

  return (
    <AccordionDetails sx={{ padding: '0px 28px 32px' }}>
      {type === 'payment_acc2acc' && (
        <GeneralDetailsMyAccounts
          accountOptions={accountOptions}
          selectedToAccount={selectedToAccount}
          onChangeToAccount={onChangeToAccount}
          control={control}
          register={register}
          disabled={disabled}
          errors={errors}
          dataForm={dataForm}
        />
      )}
      {type === 'payment_interbank' && (
        <GeneralDetailsInbank
          accountOptions={accountOptions}
          selectedToAccount={selectedToAccount}
          onChangeToAccount={onChangeToAccount}
          control={control}
          register={register}
          disabled={disabled}
          errors={errors}
          beneficiarData={beneficiarData}
          values={values}
          dataForm={dataForm}
          ibanField={ibanField}
        />
      )}
      {type === 'payment_local_transfer' && (
        <GeneralDetailsCountry
          countryDetails={countryDetails}
          value={value}
          change={change}
          control={control}
          register={register}
          customerType={customerType}
          handleChangeCustomerType={handleChangeCustomerType}
          onChangeToAccount={onChangeToAccount}
          bankCodeLocalTransferOpen={bankCodeLocalTransferOpen}
          bankCodeLocalTransferSet={bankCodeLocalTransferSet}
          localTransferBankData={localTransferBankData}
          getBankCodeData={getBankCodeData}
          transferData={transferData}
          clickLocalTransferBankCode={clickLocalTransferBankCode}
          setIsSearch={setIsSearch}
          errors={errors}
          selfPayment={selfPayment}
          switchSelf={switchSelf}
          ipsValue={ipsValue}
          handleChangeIps={handleChangeIps}
          dataIps={dataIps}
          handleSearch={handleSearchIps}
          dataForm={dataForm}
          bankCodeValueLocal={bankCodeValueLocal}
          beneficiarData={beneficiarDataLocal}
          voenLocal={voenLocal}
          beneficiarIbanLocal={beneficiarIbanLocal}
          beneficiarNameLocal={beneficiarNameLocal}
          handleChangeBeneficiarIbanLocal={handleChangeBeneficiarIbanLocal}
          handleChangeVoenLocal={handleChangeVoenLocal}
          handleChangeBeneficiarNameLocal={handleChangeBeneficiarNameLocal}
        />
      )}
      {type === 'payment_foreign_transfer' && (
        <GeneralDetailsAbroad
          control={control}
          register={register}
          errors={errors}
          countries={countries}
          selectedCountry={selectedCountry}
          handleChangeCountry={handleChangeCountry}
          mediatorBank={mediatorBank}
          handleSwitchMediatorBank={handleSwitchMediatorBank}
          openDialogSwiftBic={openDialogSwiftBic}
          setOpenDialogSwiftBic={setOpenDialogSwiftBic}
          openMediatorDialogSwiftBic={openMediatorDialogSwiftBic}
          setOpenMediatorDialogSwiftBic={setOpenMediatorDialogSwiftBic}
          transferData={transferData}
          setIsSearch={setIsSearch}
          getSwiftCode={getSwiftCode}
          handleClickSwiftCode={handleClickSwiftCode}
          bankCode={localTransferBankData}
          handleClickMediatorSwiftCode={handleClickMediatorSwiftCode}
          dataForm={dataForm}
          handleSearchSwift={handleSearchSwift}
          handleSearchMediatorSwift={handleSearchMediatorSwift}
          setSwiftCodeForeign={setSwiftCodeForeign}
          setSwiftMediatorCodeForeign={setSwiftMediatorCodeForeign}
          selectedFromAccount={selectedFromAccount}
          dataSwiftCode={dataSwiftCode}
          innForeign={innForeign}
          kppForeign={kppForeign}
          beneficiarNameForeign={beneficiarNameForeign}
          beneficiarAddressForeign={beneficiarAddressForeign}
          handleChangeInnForeign={handleChangeInnForeign}
          handleChangeKppForeign={handleChangeKppForeign}
          handleChangeBeneficiarNameForeign={handleChangeBeneficiarNameForeign}
          handleChangeBeneficiarAddressForeign={handleChangeBeneficiarAddressForeign}
        />
      )}
      {type === 'payment_edv' && (
        <GeneralDetailsEDV
          register={register}
          errors={errors}
          edvBudgetData={edvBudgetData}
          dataForm={dataForm}
          voenEdv={voenEdv}
          beneficiarNameEdv={beneficiarNameEdv}
          handleChangeVoenEdv={handleChangeVoenEdv}
          handleChangeBeneficiarNameEdv={handleChangeBeneficiarNameEdv}
        />
      )}
      {type === 'payment_budget' && (
        <GeneralDetailsBudget
          errors={errors}
          register={register}
          control={control}
          budgetLevelCodes={budgetLevelCodes}
          handleChangeSelectedBudgetValue={handleChangeSelectedBudgetValue}
          selectedBudgetLevelCodes={selectedBudgetLevelCodes}
          orgOpen={orgOpen}
          orgClose={orgClose}
          transferData={transferData}
          setIsSearch={setIsSearch}
          getOrgData={getOrgData}
          bankCode={localTransferBankData}
          clickOrgCode={clickOrgCode}
          budgetOrgCodeChange={budgetOrgCodeChange}
          dataForm={dataForm}
          budgetClassCode={budgetClassCode}
          classCodeBudget={classCodeBudget}
          dataOrganization={dataOrganization}
          dataClassification={dataClassification}
          budgetIban={budgetIban}
        />
      )}
      {type === 'credit' && <GeneralDetailsCredit />}
    </AccordionDetails>
  );
};

export default GeneralDetails;
